/* ROLLIN TRUCKSTYLE — Shopify theme JS */
(function(){
"use strict";
const $  = (s,c)=> (c||document).querySelector(s);
const $$ = (s,c)=> Array.from((c||document).querySelectorAll(s));
const eur = cents => {
  const n = (cents/100);
  const rounded = Math.round(n);
  if(Math.abs(n - rounded) < 0.005) return "€ " + rounded.toLocaleString("nl-NL") + ",-";
  return n.toLocaleString("nl-NL",{style:"currency",currency:"EUR"});
};

/* ---------- announcement bar ---------- */
const annMsg = $(".announce__msg");
if(annMsg){
  let MSGS = [];
  const annBar = annMsg.closest(".announce");
  try{ MSGS = JSON.parse((annBar && annBar.dataset.messages) || "[]"); }catch(e){ MSGS = []; }
  if(!MSGS.length) MSGS = [{t: annMsg.textContent.trim(), tone: annMsg.dataset.tone || "red"}];
  let i = 0;
  const show = n => {
    annMsg.classList.add("is-fading");
    setTimeout(()=>{
      i = (n + MSGS.length) % MSGS.length;
      annMsg.dataset.tone = MSGS[i].tone;
      annMsg.innerHTML = '<span class="announce__dot"></span>' + MSGS[i].t;
      annMsg.classList.remove("is-fading");
    }, 300);
  };
  const prev = $(".announce__nav--prev"), next = $(".announce__nav--next");
  if(prev) prev.addEventListener("click",()=>show(i-1));
  if(next) next.addEventListener("click",()=>show(i+1));
  if(MSGS.length > 1) setInterval(()=>show(i+1), 6000);
}

/* ---------- header hide/reveal ---------- */
const header = $(".header");
let lastY = 0;
if(header){
  window.addEventListener("scroll",()=>{
    const y = window.scrollY;
    if(y > 160 && y > lastY) header.classList.add("is-hidden");
    else header.classList.remove("is-hidden");
    lastY = y;
  },{passive:true});
}

/* ---------- mobile menu ---------- */
const mmenu = $(".mmenu");
const burger = $(".header__burger");
if(burger && mmenu){
  const close = ()=> mmenu.classList.remove("is-open");
  burger.addEventListener("click",()=> mmenu.classList.add("is-open"));
  const closeBtn = $(".mmenu__close");
  if(closeBtn) closeBtn.addEventListener("click",close);
  $$(".mmenu__link[data-sub]").forEach(btn=>{
    btn.addEventListener("click",()=>{ const t = $("#"+btn.dataset.sub); if(t) t.classList.toggle("is-open"); });
  });
  $$(".mmenu a[href]").forEach(a=>a.addEventListener("click",close));
}

/* ---------- toast ---------- */
let toastEl, toastTimer;
function toast(msg){
  toastEl = $("[data-toast]");
  if(!toastEl){ toastEl = document.createElement("div"); toastEl.className="toast"; toastEl.setAttribute("data-toast",""); document.body.appendChild(toastEl); }
  toastEl.innerHTML = "<i></i>" + msg;
  toastEl.classList.add("is-visible");
  clearTimeout(toastTimer);
  toastTimer = setTimeout(()=>toastEl.classList.remove("is-visible"), 2600);
}

/* ---------- Shopify AJAX cart ---------- */
const drawer = $(".drawer"), overlay = $(".overlay");
function openCart(){ if(drawer){ drawer.classList.add("is-open"); if(overlay) overlay.classList.add("is-visible"); } }
function closeCart(){ if(drawer){ drawer.classList.remove("is-open"); if(overlay) overlay.classList.remove("is-visible"); } }

function renderCart(cart){
  const wrap = $("[data-drawer-items]"); if(!wrap) return;
  $$(".cart-count").forEach(el=>{ el.textContent = cart.item_count; el.style.display = cart.item_count ? "flex" : "none"; });
  if(!cart.items.length){
    wrap.innerHTML = '<div class="drawer__empty">Je winkelwagen is leeg</div>';
  } else {
    wrap.innerHTML = cart.items.map((it,idx)=>{
      const img = it.image ? '<img src="'+it.image+'&width=128" alt="" loading="lazy">' : '';
      const variant = it.variant_title ? '<div class="dmeta">'+it.variant_title+'</div>' : '';
      const sku = it.sku ? '<div class="dmeta">'+it.sku+'</div>' : '';
      return '<div class="drawer__item">'
        + '<a href="'+it.url+'">'+img+'</a>'
        + '<div><a href="'+it.url+'" style="text-decoration:none;color:inherit;"><h4>'+it.product_title+'</h4></a>'
        + variant + sku
        + '<div class="dqty"><button type="button" data-line="'+(idx+1)+'" data-delta="-1">&minus;</button><output>'+it.quantity+'</output><button type="button" data-line="'+(idx+1)+'" data-delta="1">+</button></div>'
        + '</div>'
        + '<div><div class="dprice">'+eur(it.final_line_price)+'</div>'
        + '<button class="dremove" type="button" data-line-remove="'+(idx+1)+'">Verwijderen</button></div>'
        + '</div>';
    }).join("");
  }
  const tot = $("[data-drawer-total]"); if(tot) tot.textContent = eur(cart.total_price);
}

function refreshCart(open){
  fetch("/cart.js").then(r=>r.json()).then(cart=>{
    renderCart(cart);
    if(open) openCart();
  }).catch(()=>{});
}

function addToCart(variantId, qty, btn){
  if(btn) btn.disabled = true;
  fetch("/cart/add.js",{
    method:"POST",
    headers:{"Content-Type":"application/json","Accept":"application/json"},
    body: JSON.stringify({items:[{id: parseInt(variantId,10), quantity: qty}]})
  }).then(r=>{
    if(!r.ok) return r.json().then(e=>{ throw new Error(e.description || "Toevoegen mislukt"); });
    return r.json();
  }).then(()=>{
    toast("Toegevoegd aan winkelwagen");
    refreshCart(true);
  }).catch(err=>{
    toast(err.message || "Toevoegen mislukt");
  }).finally(()=>{ if(btn) btn.disabled = false; });
}

function changeLine(line, qty){
  fetch("/cart/change.js",{
    method:"POST",
    headers:{"Content-Type":"application/json","Accept":"application/json"},
    body: JSON.stringify({line: line, quantity: qty})
  }).then(r=>r.json()).then(cart=>renderCart(cart)).catch(()=>{});
}

$$("[data-open-cart]").forEach(b=>b.addEventListener("click",e=>{ e.preventDefault(); refreshCart(true); }));
$$("[data-close-cart]").forEach(b=>b.addEventListener("click",closeCart));
if(overlay) overlay.addEventListener("click",closeCart);

document.addEventListener("click",e=>{
  const qtyBtn = e.target.closest(".drawer__item .dqty button");
  if(qtyBtn){
    const out = qtyBtn.parentElement.querySelector("output");
    const line = parseInt(qtyBtn.dataset.line,10);
    const next = Math.max(0, parseInt(out.textContent,10) + parseInt(qtyBtn.dataset.delta,10));
    changeLine(line, next);
    return;
  }
  const rm = e.target.closest("[data-line-remove]");
  if(rm){ changeLine(parseInt(rm.dataset.lineRemove,10), 0); return; }

  const add = e.target.closest("[data-add-to-cart]");
  if(add && add.id !== "pd-add"){
    e.preventDefault();
    addToCart(add.dataset.addToCart, 1, add);
  }
});
refreshCart(false);

/* ---------- categorie carousel ---------- */
const track = $(".cats__track");
if(track && $(".cats__prev")){
  const step = ()=> Math.min(track.clientWidth*0.8, 760);
  $(".cats__prev").addEventListener("click",()=>track.scrollBy({left:-step(),behavior:"smooth"}));
  $(".cats__next").addEventListener("click",()=>track.scrollBy({left: step(),behavior:"smooth"}));
}

/* ---------- accordions ---------- */
$$(".acc-item__head").forEach(h=>{
  h.addEventListener("click",()=>{
    const item = h.parentElement, body = $(".acc-item__body",item);
    const open = item.classList.toggle("is-open");
    body.style.maxHeight = open ? body.scrollHeight + "px" : "0px";
  });
});
$$(".fgroup__title").forEach(t=>{
  t.addEventListener("click",()=>t.parentElement.classList.toggle("is-closed"));
});

/* ---------- productpagina ---------- */
const pdVariantsEl = $("#pd-variants");
if(pdVariantsEl){
  const variants = JSON.parse(pdVariantsEl.textContent);
  const pdSection = pdVariantsEl.closest(".pd");
  const selected = [];
  $$(".pd__variants", pdSection).forEach(group=>{
    const active = $(".var-btn.is-active", group);
    selected[parseInt(group.dataset.optionIndex,10)] = active ? active.dataset.value : null;
    $$(".var-btn", group).forEach(btn=>{
      btn.addEventListener("click",()=>{
        $$(".var-btn", group).forEach(b=>b.classList.remove("is-active"));
        btn.classList.add("is-active");
        selected[parseInt(group.dataset.optionIndex,10)] = btn.dataset.value;
        syncVariant();
      });
    });
  });

  function currentVariant(){
    return variants.find(v=> v.options.every((opt,idx)=> selected[idx] == null || opt === selected[idx]));
  }

  function syncVariant(){
    const v = currentVariant(); if(!v) return;
    const priceEl = $("[data-pd-price]"), exEl = $("[data-pd-price-ex]"), cmpEl = $("[data-pd-compare]");
    const stockEl = $("[data-pd-stock]"), addBtn = $("#pd-add"), addLabel = $("[data-pd-add-label]");
    const skuEl = $("[data-pd-sku]");
    if(priceEl) priceEl.innerHTML = eur(v.price) + ' <small>incl. btw</small>';
    if(exEl) exEl.textContent = eur(Math.round(v.price/1.21)) + " excl. btw";
    if(cmpEl){
      if(v.compare_at_price && v.compare_at_price > v.price){ cmpEl.textContent = eur(v.compare_at_price); cmpEl.style.display=""; }
      else cmpEl.style.display = "none";
    }
    if(stockEl) stockEl.innerHTML = v.available
      ? '<i></i><span class="mono">Op voorraad</span>'
      : '<i style="background:var(--red)"></i><span class="mono">Niet op voorraad</span>';
    if(skuEl && v.sku) skuEl.textContent = v.sku;
    if(addBtn){
      addBtn.dataset.addToCart = v.id;
      addBtn.disabled = !v.available;
      if(addLabel) addLabel.innerHTML = v.available ? "In winkelwagen &nbsp;&rarr;" : "Uitverkocht";
    }
    if(v.featured_image && v.featured_image.src){
      const main = $("#pd-main");
      if(main){ main.src = v.featured_image.src; }
    }
    const url = new URL(window.location.href);
    url.searchParams.set("variant", v.id);
    window.history.replaceState({},"",url.toString());
  }

  /* qty */
  const qtyOut = $("#qty-out");
  $$(".qty [data-q]", pdSection).forEach(b=>{
    b.addEventListener("click",()=>{
      qtyOut.textContent = Math.max(1, parseInt(qtyOut.textContent,10) + parseInt(b.dataset.q,10));
    });
  });

  /* add */
  const pdAdd = $("#pd-add");
  if(pdAdd){
    pdAdd.addEventListener("click",e=>{
      e.preventDefault();
      addToCart(pdAdd.dataset.addToCart, parseInt(qtyOut.textContent,10) || 1, pdAdd);
    });
  }
}

/* galerij thumbs */
$$(".pd__thumb").forEach(t=>{
  t.addEventListener("click",()=>{
    $$(".pd__thumb").forEach(x=>x.classList.remove("is-active"));
    t.classList.add("is-active");
    const main = $("#pd-main");
    if(main && t.dataset.src) main.src = t.dataset.src;
  });
});

/* ---------- cart pagina: qty +/- schrijft naar inputs ---------- */
$$("[data-cart-qty]").forEach(b=>{
  b.addEventListener("click",()=>{
    const input = document.querySelector('[data-qty-input="'+b.dataset.cartQty+'"]');
    if(!input) return;
    input.value = Math.max(0, parseInt(input.value,10) + parseInt(b.dataset.delta,10));
    input.closest("form").submit();
  });
});
})();
